import dayjs, { Dayjs } from "utils/dayjs"
import AmountWithCurrency, { IAmountWithCurrencyDto } from "./AmountWithCurrency"

export interface IGetLocalDepreciationDto {
    periodFrom: string
    remainingDuration: number
    additions: IAmountWithCurrencyDto
    extraordinaryDepreciation: IAmountWithCurrencyDto
    depreciationAmount: IAmountWithCurrencyDto
    bookValue: IAmountWithCurrencyDto
    taxBasedDeduction?: IAmountWithCurrencyDto | null
    specialDepreciation?: IAmountWithCurrencyDto | null
    specialDepreciationComment?: string | null
    isBookingPeriod: boolean
    isSpecialDepreciationEditable: boolean
    splitOccured: boolean
}

export class LocalDepreciation {
    periodFrom: Dayjs
    remainingDuration: number
    additions: AmountWithCurrency
    extraordinaryDepreciation: AmountWithCurrency
    depreciationAmount: AmountWithCurrency
    bookValue: AmountWithCurrency
    taxBasedDeduction: AmountWithCurrency
    specialDepreciation: AmountWithCurrency
    specialDepreciationComment?: string
    isBookingPeriod: boolean
    isSpecialDepreciationEditable: boolean
    splitOccured: boolean

    constructor(dto: IGetLocalDepreciationDto) {
        this.periodFrom = dayjs(dto.periodFrom, "YYYY-MM-DD") // take only date ignoring the time
        this.remainingDuration = dto.remainingDuration
        this.additions = new AmountWithCurrency(dto.additions)
        this.extraordinaryDepreciation = new AmountWithCurrency(dto.extraordinaryDepreciation)
        this.depreciationAmount = new AmountWithCurrency(dto.depreciationAmount)
        this.bookValue = new AmountWithCurrency(dto.bookValue)
        this.taxBasedDeduction = dto.taxBasedDeduction
            ? new AmountWithCurrency(dto.taxBasedDeduction)
            : new AmountWithCurrency({ amount: 0, currency: dto.depreciationAmount.currency })
        this.specialDepreciation = dto.specialDepreciation
            ? new AmountWithCurrency(dto.specialDepreciation)
            : new AmountWithCurrency({ amount: 0, currency: dto.depreciationAmount.currency })
        this.specialDepreciationComment = dto.specialDepreciationComment ?? undefined
        this.isBookingPeriod = dto.isBookingPeriod
        this.isSpecialDepreciationEditable = dto.isSpecialDepreciationEditable
        this.splitOccured = dto.splitOccured
    }
}
